import type {SearchResult} from 'services/elastic/types';
import type {Schemas} from 'api/dto.generated';
import type {Prize} from '../types';
import {mapGetPrizeDto} from './mapPrizeDto';

export const mapPrizeSearchDto = (
  query: string,
  dto: Schemas.LiteraturePrizesPageResponse,
): SearchResult<Prize> => {
  return {
    hits: dto.items.map(mapGetPrizeDto),
    highlights: [query],
    total: dto.totalElements,
  };
};
